import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { memberApi } from '../api';

export default function PaymentSetup() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { currentUser } = useAuth();

  useEffect(() => {
    const setupPayment = async () => {
      if (!currentUser) return;

      try {
        setLoading(true);
        setError(null);
        
        // Get the current user's ID token
        const token = await currentUser.getIdToken();
        
        // Create a checkout session and get the URL
        const facilityId = localStorage.getItem('facilityId');
        const businessId = localStorage.getItem('businessId');

        if (!businessId || !facilityId) {
          setError('Business or facility not found');
          return;
        }

        const { url } = await memberApi.createSetupIntent(currentUser.uid, token, businessId, facilityId);

        // Redirect to Stripe Checkout
        window.location.href = url;
      } catch (err: any) {
        setError(err.message || 'Error setting up payment method');
        setLoading(false);
      }
    };

    setupPayment();
  }, [currentUser]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700">
        {error}
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <div className="text-center">
        <h1 className="text-2xl font-semibold text-gray-900">Setting up your payment method...</h1>
        <p className="mt-2 text-gray-600">You will be redirected to our secure payment page.</p>
      </div>
    </div>
  );
} 